import { render, staticRenderFns } from "./AppReviewPrompt.vue?vue&type=template&id=5de87054&"
import script from "./AppReviewPrompt.vue?vue&type=script&lang=js&"
export * from "./AppReviewPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports